import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "../AppContext";
import "./css/Footer.css"; // Falls du eine CSS-Datei hast

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const { version } = useApp();

    return (
        <footer className="footer text-center py-4">
            <div className="container">
                <div className="footer-content">
                    <div className="copyright">
                        <span>&#169; {currentYear} Clavis Systems</span>
                        {version && <span className="ms-2 text-secondary">v{version}</span>}
                    </div>
                    <div className="footer-links">
                        <Link to="/impressum" className="footer-link">Impressum</Link> |  
                        <Link to="/datenschutz" className="footer-link">Datenschutz</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
